export default {
  props: {
    colorScheme: String,
  },
};
